import {MedicineDosagePackageType} from "./medicine-dosage-package-type";
import {DosageType} from "./dosage-type";
import {Medicine} from "./medicine";
import {FormControl} from "@angular/forms";
import { BatchItem } from "./batch";

export interface OrderItemStatus {
    id: number,
    status: string,
    code: string,
    created_at: string,
    updated_at: null,
    deleted_at: null
}

export interface OrderItem {
    id: number | null,
    order_id?: number;
    quantity: number;
    medicine_dosage_package_type_id: number | null;
    medicineDosagePackageType: MedicineDosagePackageType;
    dosageType: DosageType;
    medicine: Medicine;
    status: OrderItemStatus | null;
    deleted_at: Date | undefined;
    quantity_fulfilled: number;
    batch_items?: BatchItem[];
}

export enum FocusedInput {
    Barcode = 1,
    MedicineNumber = 2,  
    None = 3
}

export interface FulfilmentItem {
    orderItem: OrderItem;
    barcodeInput: FormControl;
    barcodeInputId: string;
    medicineNumberInput: FormControl;
    medicineNumberInputId: string;
    focusedInput: FocusedInput;
    scanned: number;
    errored: boolean;
    activated: boolean;
}

export interface FulfilmentPayload {
    barcode: string;
    medicine_number: string;
}